/* app/js/src/components/channel/platformsCollapsible/platforms-collapsible.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.label div[contenteditable=true]:focus {
  height: 30px;
  border-radius: 4px;
  background-color: #ffffff;
  font-size: 12px;
  border: solid 1px #e1e6eb;
  color: #232f3a;
  outline: none;
}
.label div[contenteditable=true]:focus ::-webkit-input-placeholder {
  color: #c9cdd6;
}
:host {
  width: 100%;
}
:host .container {
  border-bottom: dashed 1px #e1e6eb;
}
:host:first-of-type .container {
  border-top: dashed 1px #e1e6eb;
}
.container {
  padding-left: 3%;
  padding-right: 3%;
}
.container header {
  height: 53px;
  line-height: 10px;
  display: flex;
  align-items: center;
  position: relative;
}
.container header > div {
  display: inline-block;
}
.container header > div:first-of-type {
  width: 14px;
  height: 14px;
  border: solid 1px #e1e6eb;
  margin-right: 14px;
  cursor: pointer;
}
.container header .inactive svg {
  display: none;
}
.container header .trash-icon {
  position: absolute;
  left: 469px;
  top: 16px;
  cursor: pointer;
}
.container header .trash-icon ::ng-deep svg path {
  fill: #879baf !important;
}
.container .content {
  margin: 5px 32px 0 32px;
}
.container.open {
  padding-bottom: 24px;
}
.label {
  font-size: 12px;
  color: #232f3a;
  flex-grow: 1;
  cursor: pointer;
}
.label.inactive {
  color: #8da0b3;
}
.label div {
  font-style: italic;
  margin-right: 5px;
  display: inline-block;
  padding-left: 13px;
}
.label div[contenteditable=true]:focus {
  width: 336px;
  line-height: 30px;
}
.label span {
  color: #c9cdd6;
  font-style: italic;
  cursor: pointer;
}
.button {
  cursor: pointer;
  width: 10px;
  height: 10px;
  position: absolute;
  left: 426px;
}
.button svg path {
  fill: #879baf;
}
.button .open {
  position: relative;
  top: -4px;
  width: 12px;
  height: 15px;
}
.button .close {
  width: 12px;
  height: 15px;
  transform: rotate(-90deg);
}
.button .close svg {
  width: 16px;
  height: 10px;
}
/*# sourceMappingURL=platforms-collapsible.component.css.map */
